import { EncryptStorage } from 'encrypt-storage';
import { config } from "../services/Config";
export const encStorage = new EncryptStorage(config.encsecretKey, {
  
});